import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { LogoLockup } from "@/components/Logo";
import { useLang } from "@/i18n";

const LANGS = ["it", "de", "en"];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const { t, lang, setLang } = useLang();

  const LINKS = [
    { href: "#servizi", label: t.nav.servizi, id: "servizi" },
    { href: "#flotta", label: t.nav.flotta, id: "flotta" },
    { href: "#tariffe", label: t.nav.tariffe, id: "tariffe" },
    { href: "#prenota", label: t.nav.prenota, id: "prenota" },
    { href: "#contatti", label: t.nav.contatti, id: "contatti" },
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled ? "glass-panel border-b border-white/10 py-3" : "py-6"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 sm:px-8">
        <a href="#top" aria-label="Taxi Bellinzona home">
          <LogoLockup size={scrolled ? 30 : 38} />
        </a>
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.id}`}
              className="text-sm font-medium text-slate-300 transition-colors duration-300 hover:text-amber-400"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <div
            data-testid="lang-switcher"
            className="flex items-center gap-1 rounded-full border border-white/15 p-1"
          >
            {LANGS.map((l) => (
              <button
                key={l}
                data-testid={`lang-${l}`}
                onClick={() => setLang(l)}
                className={`rounded-full px-2.5 py-1 font-mono-alt text-[10px] font-semibold uppercase tracking-widest transition-colors duration-300 ${
                  lang === l ? "bg-amber-400 text-black" : "text-slate-400 hover:text-amber-300"
                }`}
              >
                {l}
              </button>
            ))}
          </div>
          <a
            href="tel:+41766344242"
            data-testid="nav-phone-cta"
            className="group flex items-center gap-2 rounded-full bg-amber-400 px-4 py-2.5 text-sm font-bold text-black transition-all duration-300 hover:bg-amber-300 hover:shadow-[0_0_30px_rgba(255,199,0,0.4)] sm:px-5"
          >
            <Phone className="h-4 w-4 transition-transform duration-300 group-hover:rotate-12" />
            <span className="hidden sm:inline">+41 76 634 4242</span>
            <span className="sm:hidden">{t.nav.call}</span>
          </a>
        </div>
      </div>
    </header>
  );
};
